module.exports = __webpack_public_path__ + "static/media/b_2.00a858d9.jpg";